AddressAvailability.Status.Views.Hours = class Hours extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    return this.listenTo(this.model, "change:hours", this.render);
  }

  // RENDERING

  render() {
    this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        hours: this.model.get("hours"),
        alwaysOpenText: AddressAvailability.Status.t("always_open"),
      }),
    );
    return this;
  }
};
AddressAvailability.Status.Views.Hours.prototype.tagName = "section";
AddressAvailability.Status.Views.Hours.prototype.className = "address-availability address-availability--hours";
AddressAvailability.Status.Views.Hours.prototype.template =
  "application/components/address_availability/status/templates/hours";
